import { Component, Input, OnInit } from '@angular/core';
import { TreeAdapter } from "@app/shared/util/tree-adapter.utils";

@Component({
    selector: 'app-equipment-tree',
    templateUrl: './equipment-tree.component.html',
    styleUrls: ['./equipment-tree.component.scss']
})
export class EquipmentTreeComponent implements OnInit {

    @Input() displayField: string;
    @Input() label = '';
    @Input() labelClass = {};
    @Input() loading = false;
    @Input() _items = [];
    @Input() isMaterial = true;

    constructor(private treeAdapter: TreeAdapter) {
    }

    ngOnInit() {
    }

    get items() {
        return this._items;
    }

    @Input()
    set items(items) {
        this._items = this.treeAdapter.adaptEquipmentToTree(items, this.displayField);
    }
}
